import { useContext } from "react";
import { useSearch } from "@clodo/core";
import { BrowserContext } from "../services/BrowserContext";

// L'anti-rebond, la recherche serveur et la restauration du dossier courant
// vivent dans @clodo/core : ici il ne reste que le champ de saisie.
const Search = ({elements,path,handleCurrentFolder,limit,handleSearchLimit}) => {
    const { itemsManipulator } = useContext(BrowserContext);

    const { query, setQuery } = useSearch({
        api : itemsManipulator.api,
        root : elements,
        path : path,
        limit : limit,
        onFolder : handleCurrentFolder
    });

    const handleName = (e) => {
        setQuery(e.target.value);
        handleSearchLimit(50,false);
    }

    return (
        <div className="flex-grow-1">
            <input placeholder="Search" style={{maxWidth : "250px"}} className="form-control float-end" value={query} onChange={handleName}></input>
        </div>
    )
}

export default Search
